import { useHead } from "../services/common";
import { Link } from "easy-page-router/react";

export default function NotFound() {
    useHead("404 Not Found", "Page you are looking for does not exist.");

    return (
        <div style={{ padding: "40px", textAlign: "center", fontFamily: "sans-serif" }}>
            <h1>404</h1>
            <p>Oops, page not found.</p>
            <Link href="/">Go back home</Link>
        </div>
    );
}
